<div *ngIf="!subscriptionOk" class="activity-detail">
  <div *ngIf="activity" class="activity-detail--inner" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
    <div class="activity-detail--inner--header" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
      {{activity.libelle}} <mat-icon>arrow_right_alt</mat-icon> {{activity.campagne_obj.libelle}}
    </div>
    <div class="activity-detail--inner--lines">
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Cours ou Stage</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.type_cours_label}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Catégorie du cours</span>
        <span class="activity-detail--inner--lines--line-value">{{ displayCategorieCours() }}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Activité/Sport</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.activite_obj?.libelle}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Enseignant</span>
        <span class="activity-detail--inner--lines--line-value">{{ensSvc.fullName(activity.enseignant_obj)}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Niveau</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.niveau_obj?.libelle}}</span>
      </div>
      <ng-container *ngIf="activity.type_cours === typeCours.cours">
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">Jour(s) et horaires</span>
          <span class="activity-detail--inner--lines--line-value">{{planningSvc.displayActivityDate(activity)}}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="activity.activite_obj?.description">
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">Description</span>
          <span class="activity-detail--inner--lines--line-value" [innerHTML]="activity.activite_obj?.description"></span>
        </div>
      </ng-container>
      <ng-container *ngIf="activity.type_cours === typeCours.stage">
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">Date</span>
          <span class="activity-detail--inner--lines--line-value">{{planningSvc.displayActivityDate(activity)}}</span>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="activity?.attachments_obj.length > 0">
      <div class="activity-detail--inner--lines">
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">Document(s) lié(s)</span>
          <span class="activity-detail--inner--lines--line-value"></span>
        </div>

        <div *ngFor="let file of activity?.attachments_obj; let i = index" class="activity-detail--inner--lines--line download" (click)="downloadFile(file)">
          <span class="activity-detail--inner--lines--line-value">{{i+1}} - {{file.filename}}</span>
          <span class="activity-detail--inner--lines--line-icon"><mat-icon>download</mat-icon></span>
        </div>
      </div>
    </ng-container>

    <div class="activity-detail--inner--lines">
      <ng-container>
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">&nbsp;</span>
          <span class="activity-detail--inner--lines--line-value"></span>
        </div>
      </ng-container>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Lieu</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.centre_obj?.libelle}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Adresse</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.centre_obj?.adresse}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">CP/Ville</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.centre_obj?.code_postal}} {{activity.centre_obj?.ville}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Observations</span>
        <span class="activity-detail--inner--lines--line-value">{{activity.centre_obj?.commentaire}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">&nbsp;</span>
        <span class="activity-detail--inner--lines--line-value"></span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Nombre de places</span>
        <span class="activity-detail--inner--lines--line-value">{{activity?.places_disponibles}}</span>
      </div>
      <div class="activity-detail--inner--lines--line">
        <span class="activity-detail--inner--lines--line-label">Nombre d'inscrits</span>
        <span class="activity-detail--inner--lines--line-value">{{getNbSubscriptions(activity)}}</span>
      </div>
      <ng-container *ngIf="activity.categorie_cours === planningCategorieCours.les_deux">
        <div class="activity-detail--inner--lines--line">
          <span class="activity-detail--inner--lines--line-label">{{(activity.type_cours === typeCours.stage?'Intensif':'')}} EC Libre ou loisir</span>
          <ng-container *ngIf="!subscription?.categorie_cours">
            <span class="activity-detail--inner--lines--line-value">
            <mat-radio-group [(ngModel)]="choixCategorieCours">
              <mat-radio-button [value]="subscriptionCategorieCours.ec_libre">{{subscriptionSvc.displayCategorieCours(subscriptionCategorieCours.ec_libre, activity.type_cours)}}</mat-radio-button>
              <mat-radio-button [value]="subscriptionCategorieCours.loisir">{{subscriptionSvc.displayCategorieCours(subscriptionCategorieCours.loisir, activity.type_cours)}}</mat-radio-button>
            </mat-radio-group>
          </span>
          </ng-container>
          <ng-container *ngIf="subscription?.categorie_cours">
            <span class="activity-detail--inner--lines--line-value">{{subscription?.categorie_cours_label}}</span>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="subscription.id > 0">
      <div class="activity-detail--inner--state" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
        <span class="activity-detail--inner--state-label">Votre inscription</span>
        <span class="activity-detail--inner--state-value">{{displayState(subscription?.state_subscription)}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="campagne && this.mySubscriptions.length >= this.campagne.max_inscriptions && activity.type_cours === typeCours.cours">
      <div class="activity-detail--inner--state">
        <span class="activity-detail--inner--state-value">Le nombre de vos inscriptions a atteint le nombre maximum autorisé,
         veuillez annuler une d'elles pour pouvoir continuer.</span>
      </div>
    </ng-container>
    <div class="activity-detail--inner--footer">
      <button mat-raised-button type="button" (click)="close()">Retour</button>

      <ng-container *ngIf="campagne && !registrationsOpened(campagne)">
        <button mat-raised-button type="button" (click)="subscribe()" [disabled]="true">Inscriptions fermées</button>
      </ng-container>
      <ng-container *ngIf="campagne && registrationsOpened(campagne)">
        <ng-container *ngIf="canUnsubscribe(subscription)">
          <button mat-raised-button type="button" (click)="unSubscribe()">Annuler mon inscription</button>
        </ng-container>
        <ng-container *ngIf="!canUnsubscribe(subscription)">
          <button mat-raised-button type="button" (click)="subscribe()" [disabled]="!canSubscribe(subscription) || isLocked(activity)">
              {{!isLocked(activity)? 'S\'inscrire' : 'Voir bureau des sports'}}
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="subscriptionOk" class="activity-detail">
  <div *ngIf="activity" class="activity-detail--inner" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
    <div class="activity-detail--inner--header" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
      {{activity.libelle}}
    </div>
    <div class="activity-detail--inner--lines">
      <div class="activity-detail--inner--lines--line">
        <ng-container *ngIf="activity.type_cours === typeCours.cours">
          <span class="activity-detail--inner--lines--line-value full">
            &nbsp;<br/>
            Félicitation,<br/>
            &nbsp;<br/>
            Votre inscription a bien été enregistrée.<br/>
            Cependant, celle-ci restera en attente et ne pourra être validée qu'au premier cours. <br/>
            Il est donc important de se présenter à celui-ci pour pouvoir la valider. <br />
            Merci de vérifier en amont le lieu de pratique de l'activité <br/>
            (sur le campus ou à l'extérieur),  pour prévoir vos temps de trajets.<br/>
            <ng-container *ngIf="this.getNbSubscriptions(this.activity) > activity.places_disponibles">
              <strong>Attention, le nombre de places disponibles étant dépassée, il est</strong><br/>
              <strong>possible que votre inscription ne soit pas validée.</strong><br/>
              Lors du premier cours, une réponse définitive vous sera donnée.<br/>
            </ng-container>
            Nous vous invitons également à consulter les informations générales<br/>
            sur la page SUAPS de l'université <a target="_blank" href="https://www.univ-paris8.fr/Le-service-universitaire-des-activites-physiques-et-sportives-SUAPS">ici</a>.<br/>
            &nbsp;<br/>
            L'équipe SUAPS<br/>
          </span>
        </ng-container>

        <ng-container *ngIf="activity.type_cours === typeCours.stage">
          <span class="activity-detail--inner--lines--line-value full">
            &nbsp;<br/>
            Félicitation, <br/>
            &nbsp;<br/>
            <ng-container *ngIf="subscription.categorie_cours == subscriptionCategorieCours.loisir">
              Votre inscription au stage a bien été enregistrée.<br/>
              Cependant, celle-ci restera en attente et ne pourra être validée qu'auprès du SUAPS<br/>
              aux dates spécifiques indiquées sur la brochure ou dans le résumé de votre inscription en ligne.<br/>
              Nous vous rappelons également que des documents sont à remplir et disponibles uniquement au SUAPS.<br/>
            </ng-container>
            <ng-container *ngIf="subscription.categorie_cours == subscriptionCategorieCours.ec_libre">
              Votre inscription au stage intensif a bien été enregistrée.<br/>
              Cependant, celle-ci restera en attente et l'enseignant reviendra vers vous pour vous confirmer l'inscription.<br/>
            </ng-container>
            &nbsp;<br/>
            L'équipe SUAPS<br/>
          </span>
        </ng-container>

      </div>
    </div>
    <div class="activity-detail--inner--footer full">
      <button mat-raised-button type="button" (click)="close()">Fermer</button>
    </div>
  </div>
</div>
